<template>
  <v-card>
    <v-card-title>Meta x Realizado</v-card-title>
    <v-card-text>
      <Chart :chartOptions="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from "@/components/BaseChart";
import { mapGetters } from "vuex";
export default {
  components: {
    Chart
  },
  data() {
    return {
      realizado: ["novos", "p1", "usados"],
      meta: ["metaNovos", "metaConsorcios", "metaUsados"],
      chartOptions: {
        chart: {
          type: "column",
          height: "350"
        },

        title: {
          text: ""
        },

        xAxis: {
          categories: ["Novos", "Consórcio", "Usados"],
          crosshair: true,
          accessibility: {
            description: "Countries"
          }
        },

        yAxis: {
          min: 0,
          title: {
            text: "Nº de negócios"
          }
        },

        colors: ["#CC152C", "#212121"],

        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },

        series: [],

        credits: {
          enabled: false
        },

        lang: {
          noData: "Não há dados para serem apresentados"
        },

        noData: {
          style: {
            fontWeight: "normal",
            fontSize: "1rem",
            color: "rgba(0, 0, 0, 0.6)"
          }
        }
      }
    };
  },

  computed: {
    ...mapGetters("relatorios", ["getRelatorios"])
  },

  watch: {
    getRelatorios(value) {
      this.chartOptions.series = [];
      this.createSeriesMeta(value);
      this.createSeriesRealizado(value);
    }
  },

  methods: {
    createSeriesMeta(data) {
      let values = [];

      this.meta.forEach(element => {
        values.push(data[element]);
      });

      this.chartOptions.series.push({
        name: "Meta",
        data: values
      });
    },

    createSeriesRealizado(data) {
      let values = [];

      this.realizado.forEach(element => {
        values.push(data[element].qtd);
      });

      this.chartOptions.series.push({
        name: "Realizado",
        data: values
      });
    }
  }
};
</script>

<style></style>